import React, { useState, useEffect } from 'react'
import { Progress } from 'react-sweet-progress'
import Popup from 'reactjs-popup'
import 'react-sweet-progress/lib/style.css'
import Loader from 'react-loader-spinner'
import BaseNavbar from '../../components/BaseNavbar'
import BaseFooter from '../../components/BaseFooter'
import Documents from '../../assets/Documents.png'
import Cancel from '../../assets/Cancel.png'
import Upload from '../../assets/Upload.png'

import {
  buildUploadUlr,
  getDocumentsList,
  uploadFile,
  deleteDocumentById,
} from '../../services/documents'

import './style.scss'
import COLORS from 'styles/colors'

const DocumentsPage = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const userId = urlParams.get('id')
  const token = urlParams.get('token')

  useEffect(() => {
    getDocumentsList(userId, token)
      .then((res) => setFileList(res.data))
      .catch((err) => {
        setError(`Erro em carregar lista de documentos. Detalhes técnicos: ${err}`)
        console.log('getDocumentsList =>', err)
      })
  }, [token, userId])

  const [file, setFile] = useState('')
  const [error, setError] = useState('')
  const [percentage, setPercentage] = useState(0)
  const [fileList, setFileList] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const getListOfFiles = () => {
    setPercentage(20)
    setIsLoading(true)

    setFile('')

    buildUploadUlr(userId, file.type, file.size, file.name, token)
      .then((res) => {
        file.id = res?.id
        setPercentage(70)
        uploadFile(res.upload_url, file.type, res.field_weight, res.field_name)
          .then((res) => {
            setPercentage(100)
            setIsLoading(false)
            setFileList([...fileList, file])
          })
          .catch((err) => {
            setError(`Erro em carregar lista de documentos. Detalhes técnicos: ${err}`)

            setIsLoading(false)
          })
      })
      .catch((err) => {
        setError(`Erro em carregar lista de documentos. Detalhes técnicos: ${err}`)
        setIsLoading(false)
        console.log(`Error in getListOfFiles ${err}`)
      })
  }

  const removeItemFromlist = (item) => {
    const keyItem = fileList.indexOf(item)

    deleteDocumentById(item.file_id || item.id, token)
      .then(() => {
        setFileList([...fileList.slice(0, keyItem), ...fileList.slice(keyItem + 1)])
      })
      .catch((err) => {
        setError(
          `Erro em deletar esse arquivo da sua
            lista de documentos. Detalhes técnicos: ${err}`,
        )
        console.log(`Error removeItemFromlist => ${err}`)
      })
  }

  return (
    <>
      <BaseNavbar headerText='Enviar documentos' />
      {Boolean(error) && <p style={errorMessage}>{error}</p>}
      <div className='document_header'>
        <div className='document_header_text'>Você pode enviar</div>
        <div className='document_header_text'>seus documentos aqui:</div>
      </div>

      <div className='document_list'>
        {fileList.map((item, index) => (
          <div key={index}>
            <div className='document_item'>
              <img src={Documents} alt='documents' className='document_icon' />
              <div className='document_text-item'>{item.name || item.external_filename}</div>
              <Popup
                modal
                closeOnDocumentClick
                trigger={
                  <span>
                    <img src={Cancel} alt='cancel' className='document_cancel' />
                  </span>
                }
              >
                {(close) => (
                  <div style={modalContent}>
                    <div style={{ paddingLeft: '10px' }}>Você deseja remover esse documento?</div>
                    <div style={contentButton}>
                      <button
                        style={swiftBackground('deleteButton')}
                        onClick={() => {
                          removeItemFromlist(item)
                          close()
                        }}
                      >
                        Deletar
                      </button>
                      <button style={swiftBackground('cancelButton')} onClick={() => close()}>
                        Cancelar
                      </button>
                    </div>
                  </div>
                )}
              </Popup>
            </div>
          </div>
        ))}
      </div>

      <div className='document_list'>
        {isLoading && (
          <div className='document_item'>
            <img src={Documents} alt='documents' className='document_icon' />
            <Progress percent={percentage} />
          </div>
        )}
      </div>
      <div className='document_upload'>
        <div>
          <img src={Upload} alt='upload' className='document_upload-icon' />
        </div>
        <label htmlFor='document input-file'>
          {Boolean(file) ? file.name : 'Selecione o arquivo que deseja enviar'}
        </label>
        <input
          id='document input-file'
          type='file'
          value=''
          onChange={(e) => setFile(e.target.files[0])}
        />
        <span id='file-name'></span>
      </div>
      {isLoading ? (
        <div style={loadingSpinner}>
          <Loader
            type='Oval'
            color='#00BFFF'
            height={60}
            width={60}
            style={{ marginTop: '50px' }}
          />
        </div>
      ) : (
        <div className='document_content-button'>
          <button disabled={!file} onClick={() => getListOfFiles()} className='document_button'>
            CONFIRMAR
          </button>
        </div>
      )}
      <BaseFooter />
    </>
  )
}

const errorMessage = {
  color: COLORS.uiSpecific.danger,
  textAlign: 'center',
  margin: '16px',
}

const loadingSpinner = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '-50px',
}

const modalContent = {
  height: '113px',
  width: '100%',
  paddingTop: '20px',
  display: 'flex',
  flexFlow: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}

const contentButton = {
  display: 'flex',
  justifyContent: 'space-evenly',
  marginTop: '10px',
}

const swiftBackground = (bkg) => ({
  paddingLeft: '12px',
  paddingRight: '12px',
  paddingTop: '10px',
  paddingBottom: '10px',
  outline: 'none',
  border: 'none',
  width: '100%',
  background: bkg === 'deleteButton' ? '#2B79BE' : '#c4c4c4',
  marginRight: '12px',
  cursor: 'pointer',
  color: '#fff',
  fontWeight: '700',
})

export default DocumentsPage
